import { createStyles, makeStyles } from "@material-ui/core";
export var useTitleBlockStyle = makeStyles(function () { return createStyles({ root: {} }); });
//# sourceMappingURL=titleBlock.style.js.map